import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Rubber Chicken Conspiracy",
  date: new Date(2025, 5, 22),
  img: "/img/rubber-chicken.jpeg",
  tracks: [
    {
      title: "Hot Shots",
      src: "/songs/2025-06-22/hot_shots.mp3",
      duration: 563.208,
    },
    {
      title: "I Lost My Keys",
      src: "/songs/2025-06-22/i_lost_my_keys.mp3",
      duration: 1428.24,
    },
    {
      title: "What It's All About",
      src: "/songs/2025-06-22/what_its_all_about.mp3",
      duration: 738.144,
    },
    {
      title: "Exotic Aviary",
      src: "/songs/2025-06-22/exotic_aviary.mp3",
      duration: 714.504,
    },
    {
      title: "Slippery Slope",
      src: "/songs/2025-06-22/slippery_slope.mp3",
      duration: 434.256,
    },
    {
      title: "All The Hard Work",
      src: "/songs/2025-06-22/all_the_hard_work.mp3",
      duration: 620.4,
    },
    {
      title: "Flying Car Show",
      src: "/songs/2025-06-22/flying_car_show.mp3",
      duration: 390.72,
    },
    {
      title: "New Keyboard",
      src: "/songs/2025-06-22/new_keyboard.mp3",
      duration: 1096.512,
    },
    {
      title: "How Many Times",
      src: "/songs/2025-06-22/how_many_times.mp3",
      duration: 978.192,
    },
    {
      title: "Breakfast Jazz Club",
      src: "/songs/2025-06-22/breakfast_jazz_club.mp3",
      duration: 1009.752,
    },
    {
      title: "Get A Cat",
      src: "/songs/2025-06-22/get_a_cat.mp3",
      duration: 1056.576,
    },
    {
      title: "Twelve",
      src: "/songs/2025-06-22/twelve.mp3",
      duration: 1204.128,
    },
    {
      title: "Ghost",
      src: "/songs/2025-06-22/ghost.mp3",
      duration: 1772.112,
    },
  ],
};
export default album;
